import type { ReactElement } from 'react';

import { Field, formatDateTime } from '@/components/vacancy-complaints/Field';
import { COMPLAINT_REASON_LABEL } from '@/lib/vacancyComplaintLabels';
import type { VacancyComplaintDetail } from '@/lib/vacancyComplaintsSchemas';

interface ComplaintSectionProps {
    complaint: VacancyComplaintDetail;
}

/**
 * Блок «Жалоба» детали (design-spec §2.5): причина, дата, комментарий
 * (plain-text, SF-14), автор-профи (виден ТОЛЬКО здесь — MF-7) + дата
 * решения / причина модератора после разбора.
 */
export function ComplaintSection({ complaint }: ComplaintSectionProps): ReactElement {
    return (
        <section data-testid="vacancy-complaint-info">
            <h2 className="mb-3 text-base font-semibold text-gray-900">Жалоба</h2>
            <dl className="grid grid-cols-1 gap-3 text-sm sm:grid-cols-2">
                <Field
                    label="Причина"
                    value={COMPLAINT_REASON_LABEL[complaint.reason]}
                    testId="vacancy-complaint-reason"
                />
                <Field label="Дата" value={formatDateTime(complaint.createdAt)} />
                <Field
                    label="Комментарий"
                    value={complaint.comment}
                    wide
                    multiline
                    testId="vacancy-complaint-comment"
                />
                <Field
                    label="Автор (профи)"
                    value={complaint.author.displayName}
                    testId="vacancy-complaint-author"
                />
                <Field label="Автор (userId)" value={complaint.author.userId} />
                {complaint.status !== 'pending' && (
                    <Field
                        label="Дата решения"
                        value={formatDateTime(complaint.resolvedAt)}
                    />
                )}
                {complaint.moderatorReason !== null && (
                    <Field
                        label="Причина модератора (для кафе)"
                        value={complaint.moderatorReason}
                        wide
                        multiline
                        testId="vacancy-complaint-moderator-reason"
                    />
                )}
            </dl>
        </section>
    );
}
